import { WithSubpages } from '../../subpages';
import { wapSubpages } from '../../subpages/dictionary';
import { PAGE_TITLE } from '../../consts';

import { MAIN_PAGE_PATH } from './paths';

const WAP = () => <WithSubpages mainPagePath={MAIN_PAGE_PATH} title={PAGE_TITLE.WAP} items={wapSubpages} />;

export default WAP;
